import { ca } from '@cian/analytics';

export function trackFaqAccordionOpenClick(modalTitle: string, question: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'DealSaleCcPromo',
    action: 'Click_sopr',
    label: `FAQ/${modalTitle}/${question}`,
  });
}
